export * from './BathroomIcon'
